import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalContext from 'contexts/ModalContext'
import BusinessTravellerRequestDemoModal from 'businessTraveller/components/demo-form/BusinessTravellerRequestDemoModal'
import { getImageUrl } from 'lib/image/imageUtils'
import { rem } from 'polished'
import React, { useCallback, useContext } from 'react'
import styled from 'styled-components'

const SectionContainer = styled(LayoutContainer)`
  padding-top: ${rem(48)};
  padding-bottom: ${rem(48)};

  ${mediaQueryUp.desktop} {
    padding-top: ${rem(80)};
    padding-bottom: ${rem(80)};
  }
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${rem(8)};
  overflow: hidden;

  ${mediaQueryUp.desktop} {
    flex-direction: row;
    align-items: stretch;
  }
`

const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${rem(32)} ${rem(24)};
  background: #eaebec;
  order: 1;

  ${mediaQueryUp.desktop} {
    padding: ${rem(40)};
    order: 0;
  }
`

const ImageArea = styled.div`
  order: 0;

  ${mediaQueryUp.desktop} {
    flex: 0 0 50%;
    order: 1;
  }
`

const SectionImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const BodyTextWrapper = styled.div`
  ${mediaQueryUp.desktop} {
    max-width: ${rem(485)};
  }
`

function BusinessTravellerInActionSection() {
  const showModal = useContext(ModalContext)
  const openDemoModal = useCallback(() => {
    showModal(<BusinessTravellerRequestDemoModal />)
  }, [showModal])

  return <SectionContainer>
    <Card>
      <ContentArea>
        <Group direction="vertical" gap={16}>
          <Heading variant="heading3" style={{ fontWeight: 500, lineHeight: rem(28) }}>See Business Traveller in action</Heading>
          <Group direction="vertical" gap={24}>
            <BodyTextWrapper>
              <BodyText variant="large">
                Book a 1:1 demo with a product expert to see how Business Traveller works, from setting policies to making a booking. No obligation, just a practical walk-through tailored to your business.
              </BodyText>
            </BodyTextWrapper>
            <div>
              <TextButton kind="primary" size="medium" onClick={openDemoModal}>
                Book a free demo
              </TextButton>
            </div>
          </Group>
        </Group>
      </ContentArea>
      <ImageArea>
        <SectionImage
          src={getImageUrl('laptop-show-lebt-website-v2')}
          alt="Business Traveller platform"
        />
      </ImageArea>
    </Card>
  </SectionContainer>
}

export default BusinessTravellerInActionSection
